import apiHelper from "services/apiHelper";
import useSWR from "swr";

export const getAllproductSubCategories = () => {
    return apiHelper(`api/v1/productSubCategories/get_all_sub_categories`, "get", {}, {})
};

export const getAllproductSubCategoriesFromCategory = (categoryId) => {
  return apiHelper(`api/v1/productSubCategories/get_sub_categories_from_category/${categoryId}`, "get", {}, {})
};

export const saveProductSubCategory = (id, payload) => {
    return apiHelper(id ? `api/v1/productSubCategories/update_sub_category/${id}` : `api/v1/productSubCategories/create_sub_category`, id ? "patch" : "post", payload, {})
}

export const deleteSingleProductSubCategory = (id) => {
    return apiHelper(`api/v1/productSubCategories/delete_sub_category/${id}`, "delete", {}, {})
}

export function getPaginatedProductSubCategoryAPI({ params }) {
    return apiHelper(`api/v1/productSubCategories/get_all_sub_categories?${params.query}`, "get", null, {});
  }
  
  const getproductCategoriesFetcher = async ({ url, ...params }) => {
    const searchData = await getPaginatedProductSubCategoryAPI({
      params,
    });
    
    
    return searchData.data.data;
  };
  
  
  const usePaginatedproductSubCategories = (params) => {
    return useSWR(
      params
        ? {
            url: `/api/productSubCategories`,
            ...params,
          }
        : null,
        getproductCategoriesFetcher,
      {
        revalidateOnFocus: false,
        dedupingInterval: 3000,
        errorRetryCount: 3,
      }
    );
  };

export default usePaginatedproductSubCategories;